import IndexScreenInvoiceDetail from './screens/Index.Screen';

const InvoiceDetailPage = () => {
  return <IndexScreenInvoiceDetail />;
};

export default InvoiceDetailPage;
